// extracted by mini-css-extract-plugin
export default {"container":"ErrorFallback_container__L2xQx","main":"ErrorFallback_main__re5jd","message":"ErrorFallback_message__k06w0"};